import React from "react";

//dropdown icons
import u43 from '../../images/hsa-dashboard/u43.png'


//dashboard icons
import u427 from '../../images/accounts/u427.png'
import u224 from '../../images/hsa-dashboard/u224.png'
//account icons
import u215 from '../../images/hsa-dashboard/u215.png'
import u418 from '../../images/accounts/u418.png'
//claims icons
import u229 from '../../images/hsa-dashboard/u229.png'
import u1478 from '../../images/claims/u1478.png'
//resources icons
import u239 from '../../images/hsa-dashboard/u239.png'
import u2203 from '../../images/resources/u2203.png'


export default class Nav extends React.Component{
    constructor(props){
        super(props);
        this.state={
            accounts_is_dropped:true,
            claims_is_dropped:true
        }
    }

    render(){
        const {page} = this.props;
        const {accounts_is_dropped,claims_is_dropped}=this.state
        return(
            <div style={{display:'flex',paddingTop:"2vh", width:"30.1vw",justifyContent:'flex-end',paddingRight:"1%"}}>
                <div >
                    <div style={styles.navItem} > {/**Dashboard Nav Item */}
                        <div>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="dashboard"?u224:u427} alt='u427u224'/>
                        </div>
                        <span onClick={()=>{this.props.navigator('/Dashboard');}} style={page==="dashboard"?styles.iconedNavTextSelected:styles.iconedNavText}>Dashboard</span>
                    </div>
                    <div style={styles.dropdownItem} onClick={()=>{this.setState({accounts_is_dropped:!accounts_is_dropped})}}> {/**Accounts Dropdown Item */}
                        <div style={{alignItems:'center'}}>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page.includes('account')?u418:u215} alt='u418u215'/>
                        </div>
                        <span style={page.includes('account')?styles.iconedNavTextSelected:styles.iconedNavText}>Accounts</span>
                        <div style={styles.dropdownIcon}>
                            <img style={{ maxHeight: '100%', width: 'auto', transform:accounts_is_dropped?'scaleY(-1)': 'scaleY(1)'}} src={u43} alt='u43'/>
                        </div>
                    </div>
                    {accounts_is_dropped?<div style={styles.dropdownContainer}> {/**Accounts Dropdown Group */}
                        <div onClick={()=>{this.props.navigator('/Account/Activity');}} style={styles.indentedNavItem}>
                            <span style={page==="accountActivity"?styles.indentedNavTextSelected:styles.indentedNavText}>Account Activity</span>
                        </div>
                        <div onClick={()=>{this.props.navigator('/Account/Management')}} style={styles.indentedNavItem}>
                            <span style={page==="accountManagement"?styles.indentedNavTextSelected:styles.indentedNavText}>Account Managment</span>
                        </div>
                        <div onClick={()=>{this.props.navigator('/Account/Cards')}} style={styles.indentedNavItem}>
                            <span style={page==="accountCards"?styles.indentedNavTextSelected:styles.indentedNavText}>Cards</span>
                        </div>
                        {/* <div style={styles.indentedNavItem}>
                            <span style={styles.indentedNavText}>My Profile</span>
                        </div> */}
                    </div>:null}
                    <div style={styles.dropdownItem} onClick={()=>{this.setState({claims_is_dropped:!claims_is_dropped})}}> {/**Claims Dropdown Item */}
                        <div style={{alignItems:'center'}}>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="claims"?u1478:u229} alt='u1478u229'/>
                        </div>
                        <span style={page==="claims"?styles.iconedNavTextSelected:styles.iconedNavText}>Claims</span>
                        <div style={styles.dropdownIcon}>
                            <img style={{ maxHeight: '100%', width: 'auto', transform:claims_is_dropped?'scaleY(-1)': 'scaleY(1)'}} src={u43} alt='u43'/>
                        </div>
                    </div>
                    {claims_is_dropped?<div style={styles.dropdownContainer}> {/**Claims Dropdown Group */}
                        {/* <div style={styles.indentedNavItem}>
                            <span style={page=='claimsActivity'?styles.indentedNavTextSelected:styles.indentedNavText}>Claims Activity</span>
                        </div> */}
                        <div onClick={()=>{this.props.navigator('/Claims/SubmitExpense');}} style={styles.indentedNavItem}>
                            <span  style={page==='submitExpense'?styles.indentedNavTextSelected:styles.indentedNavText}>Submit Expense</span>
                        </div>
                        {/* <div style={styles.indentedNavItem}>
                            <span style={styles.indentedNavText}>Reimbursement Method</span>
                        </div> */}
                    </div>:null}
                    <div style={styles.navItem} onClick={()=>{this.props.navigator('/Resources')}}> {/**Resources Nav Item */}
                        <div>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="resources"?u2203:u239} alt='u239u2203'/>
                        </div>
                        <span style={page==="resources"?styles.iconedNavTextSelected:styles.iconedNavText}>Resources</span>
                    </div>
                </div>
            </div>
        )
    }
}

const styles={
    iconedNavText:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0.5vw",
        verticalAlign: 'middle',
        width:'5vw',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    iconedNavTextSelected:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0.5vw",
        verticalAlign: 'middle',
        width:'5vw',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#003F97"
    },
    navItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
    },
    dropdownItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
        cursor:'pointer'
    },
    dropdownIcon:{
        display:'flex',
        alignItems:'flex-end',
        marginLeft:"3.7vw"
    },
    dropdownContainer:{
        display:'flex',
        flexDirection:'column'
    },
    indentedNavItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
        whiteSpace:'nowrap'
    },
    indentedNavText:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"1.7vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    indentedNavTextSelected:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"1.7vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:600,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
}